import React from 'react';

// components
import PageHeader from './components/page-header/page-header';
import MainBanner from './components/main-banner/main-banner';
import ArticleOne from './components/content-articles/article-one';
import ArticleTwo from './components/content-articles/article-two';
import ArticleContact from './components/content-articles/article-contact';

function App() {
  return (
    <div>
      <header className='page-header'>
        <PageHeader />
      </header>
      <div className='content-container'>
        <MainBanner id="home" />
        <ArticleOne />
        <ArticleTwo id="tech" />
        <ArticleContact id="contact" />
      </div>
    </div>
  );
}

export default App;
